
export default {
  version: "1.0.5",
  date: "September 2025",
  NotesComponent: () => (
    <ul className="pl-8 pr-8 list-disc list-inside text-left text-sm max-h-[450px] overflow-y-auto space-y-1">
      <li>Historical release notes can now be accessed above.</li>
      <li>Added new dice roller tool.</li>
      <li>Added copy and paste button option to notepad tool.</li>
      <li>Teams account system now available.</li>
      <li>The table tool can now export as a CSV.</li>
      <li>Fixed rounding, factorials, and implicit multiplication errors when using the calculator tool.</li>
    </ul>
  ),
};
